export default __webpack_public_path__ + "static/scores@992-12186a74c2fdc7262612e2bf5a346da2.png";